var $ = require('jQuery');
var Component = require('./Component');
var dispatcher = require('../global/dispatcher');
var ActionType = require('../constant/ActionType');
var template = require('../template/video-viewer.html');
var msgitem;
var videoPlayerEle;
var onPalyPaused = function () {
  dispatcher.dispatch({
    type: ActionType.VIDEO_PLAY_PASUED,
    data: msgitem
  });
};
var onPalyEnded = function () {
  dispatcher.dispatch({
    type: ActionType.VIDEO_PLAY_END,
    data: msgitem
  });
};
var onPlayStart = function () {
  this.show();
  videoPlayerEle[0].play();
  dispatcher.dispatch({
    type: ActionType.VIDEO_PLAY_START,
    data: msgitem
  });
  dispatcher.dispatch({
    type: ActionType.FULLSCREEN_OPEN
  });
};
var onPalyError = function (error) {
  this.close();
  var errorMsg = '未知错误!';
  if (error && error.code) {
    var errorArr = ['用户已终止视频请求', '您的网络异常，请检查后重试', '视频解码错误', '视频已过期'];
    errorMsg = errorArr[error.code - 1];
  }
  dispatcher.dispatch({
    type: ActionType.VIDEO_PLAY_ERROR,
    data: {
      msg: msgitem,
      error: {
        error_code: error.code,
        error_msg: errorMsg
      }
    }
  });
};

var VideoPlayer = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    Component.call(self, defaults);
    videoPlayerEle = self._element.find('.im-video-player');
    videoPlayerEle[0].onended = function () {
      onPalyEnded();
    };
    videoPlayerEle[0].onpause = function () {
      onPalyPaused();
    };
    videoPlayerEle[0].oncanplay = function () {
      onPlayStart.call(self);
    };
    videoPlayerEle[0].onerror = function () {
      var error = videoPlayerEle[0].error;
      onPalyError.call(self, error);
    };
    videoPlayerEle[0].onclick = function (e) {
      if (e.offsetX < 485 || e.offsetY < 378) {
        e.stopPropagation();
        e.preventDefault();
        videoPlayerEle[0].paused ? videoPlayerEle[0].play() : videoPlayerEle[0].pause();
      }
    };
  })(this);

  (function (self) {
    self._element.click(function (e) {
      e.stopPropagation();
      e.preventDefault();
      self.close();
    })
  })(this);
};
VideoPlayer.prototype = Object.create(Component.prototype);
VideoPlayer.prototype.play = function (msg) {
  if (typeof (msg) === 'string') {
    videoPlayerEle.attr('src', msg);
  } else {
    msgitem = msg;
    videoPlayerEle.attr('src', msg.content.url);
  }
};
VideoPlayer.prototype.stop = function () {
  if (!videoPlayerEle[0].paused) {
    videoPlayerEle[0].pause();
  }
};
VideoPlayer.prototype.close = function () {
  this.stop();
  this.hide();
  dispatcher.dispatch({
    type: ActionType.FULLSCREEN_CLOSE
  });
};
VideoPlayer.prototype.show = function () {
  this._element.show();
};
VideoPlayer.prototype.hide = function () {
  this._element.hide();
};

module.exports = VideoPlayer;